var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 3.306a12.826 12.826 0 0 0-9.8 21.116l.233.272h19.134l.233-.272A12.825 12.825 0 0 0 14 3.306Zm6.689 7.373-4.605 4.519a2.332 2.332 0 1 1-1.096-1.105l4.596-4.519 1.105 1.105ZM2.8 15.478h2.644v1.555H2.77c0-.303-.039-.599-.039-.91 0-.31.016-.428.031-.645H2.8ZM6.596 7.7l1.913 1.913-1.143 1.074L5.444 8.78c.345-.393.717-.762 1.113-1.104l.039.023Zm8.182-.086h-1.556V4.892H14c.288 0 .544 0 .778.04v2.682Zm10.492 8.517c0 .303 0 .615-.039.91h-2.738v-1.556h2.746c.015.21.031.428.031.646Z",
  fill: "#FA530A"
})));

export { SvgIconDashboard as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-dashboard.8ce4ddbf.svg";